<template>
  <div>
    <Header />
    <main>
      <section class="shop">
        <i class="fas fa-star"></i>
        <h1>Reviews</h1>
      </section>
      <section class="reviews">
        <div class="average-rating">
          <h2>Average Rating</h2>
          <p class="stars">{{ averageRating.toFixed(1) }} / 5 ⭐</p>
        </div>

        <div v-if="reviews.length > 0" class="review-list">
          <div v-for="review in reviews" :key="review.id" class="review-item">
            <div class="review-header">
              <h3>{{ review.name }}</h3>
              <span class="stars">{{ review.rating }} / 5</span>
            </div>
            <p class="description">{{ review.description }}</p>
          </div>
        </div>
        <div v-else class="no-reviews">
          <p>No reviews yet.</p>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Header from '../Header/Header.vue'
import { collection, getDocs, query } from 'firebase/firestore'
import {db} from "@/firebase";

export default {
  name: 'Reviews',
  components: { Header },
  data() {
    return {
      reviews: [],
      averageRating: 0
    }
  },
  async mounted() {
    try {
      const fetchedReviews = await this.getReviews()
      this.reviews = fetchedReviews
      const total = this.reviews.reduce((sum, r) => sum + r.rating, 0)
      this.averageRating = this.reviews.length ? total / this.reviews.length : 0
    } catch (error) {
      console.error('Error loading reviews:', error)
    }
  },
  metaInfo() {
    return {
      title: "Reviews | ShopT"
    }
  },
  methods: {
    async getReviews() {
      try {
        const querySnapshot = await getDocs(query(collection(db, 'reviews')))
        const results = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        return results.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds)
      } catch (error) {
        console.error('Error fetching reviews:', error)
        throw error
      }
    }
  },
}
</script>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  color: #fff;
  text-align: center;
}

.reviews {
  width: 100%;
  max-width: 800px;
  background-color: #222;
  border: 2px solid #444;
  border-radius: 10px;
  padding: 2rem;
  margin-top: 3rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.average-rating {
  margin-bottom: 2rem;
}

.average-rating h2 {
  font-size: 2rem;
  color: cornflowerblue;
  margin-bottom: 0.5rem;
}

.average-rating .stars {
  font-size: 1.8rem;
  color: #ffd700;
}

.review-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.review-item {
  background-color: #111;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #333;
  text-align: left;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.review-header h3 {
  font-size: 1.2rem;
  color: #fff;
}

.review-header .stars {
  color: #ffd700;
  font-weight: bold;
}

.description {
  font-size: 1rem;
  color: #ccc;
}

.no-reviews {
  font-size: 1.2rem;
  color: #999;
}
.shop {
  width: 100%;
  max-width: 400px;
  margin: 3rem 0;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-bottom: 5px solid cornflowerblue;
}

.shop i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}

.shop h1 {
  text-transform: uppercase;
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: 1px;
}
</style>
